import React, { useState } from 'react'
import { LoginForm,Geetest } from './interface'
import { loginApi, NeedGeetestCheck } from '../../api/index'
import { useNavigate } from 'react-router-dom'
import { LocalKeysEnum, localSet } from '../../core/local'
import { getQueryString } from '../../routers/util'
import { ResultEnum } from '../../enums'
import $message from '../../ui/messge/index'
import './index.css'
import { GtValidate } from '../../interface'
function Login() {
    const owner:string = getQueryString('owner')
    const navigate = useNavigate()
    const [user, setUser] = useState<LoginForm>({owner: owner || '',userName: '',password: ''})
    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const name = e.target.name
        setUser({ ...user, [name]: e.target.value })
    }
    const login = async (geetest?: Geetest) => {
        localSet(LocalKeysEnum.OWNER, user.owner)
        let postParams = {
            userName:user.userName,
            password:user.password,
        }
        if(geetest){
            postParams = { ...postParams, ...geetest }
        }
        const res = await loginApi(postParams)
        if(res.code === ResultEnum.SUCCESS){
            localSet(LocalKeysEnum.TOKEN, res.data)
            navigate('/')
        }else{
            switch (res.code) {
            case ResultEnum.MISSOWNER:
            case ResultEnum.INVALIDOWNER:
                $message.error('集团域名错误!')
                break
            case ResultEnum.INVALIDUSER:
                $message.error('用户名或密码错误!')
                break
            default:
                $message.error(res.message)
                break
            }
        }
    }
    const confrom = async ()=>{
        const postParams = {
            userName:user.userName
        }
        const res = await NeedGeetestCheck(postParams)
        let result = null
        if( typeof res.data === 'string'){
            result = JSON.parse(res.data) 
        }
        if(result){
            clearGeetestPopTag()
            if (window.initGeetest && result) {
                window.initGeetest(
                    {
                        gt : result.gt,
                        challenge : result.challenge,
                        product : 'popup',
                        new_captcha: true,
                        offline : !result.success,
                    },
                    handleEmbed
                )
            }
            return
        }
        login()
    }
    const clearGeetestPopTag = ()=>{
        const popNodes = Array.from(document.querySelectorAll('.gt_holder.gt_popup'))
        for(const node of popNodes) {
            if(node.parentNode){
                node.parentNode.removeChild(node)
            }
        }
    }
    const handleEmbed = (captcha: { 
            onSuccess: (arg0: () => void) => void; 
            getValidate: () => GtValidate; 
            appendTo: (arg0: string) => void;
            onReady: (arg0: () => void) => void 
        }) => {
        captcha.onSuccess(() => {
            const validate:GtValidate = captcha.getValidate()
            if (!validate) {
                $message.error('请先完成验证')
                return
            }
            login({
                GeetestChallenge : validate.geetest_challenge,
                GeetestValidate : validate.geetest_validate,
                GeetestSeccode : validate.geetest_seccode,
            })
        })
        captcha.appendTo('#embed-captcha')
        captcha.onReady(() => {
            const dom =  document.querySelector('.gt_holder.gt_popup')
            if(dom){
                dom.className += ' gt_show'
            }
        })
    }
    return (
        <div className="login">
            <div className='left_box'>
            </div>
            <div className='right_box'>
                <div className='logo'>
                    <img alt='图标' style={{width:180}} src={require('../../assets/images/icon.png')} />
                    <div style={{marginTop:20,color:'#4c6379'}} className='title'>应急报表</div>
                </div>
                <div className='from'>
                    <div className='row'>
                        <input placeholder='集团域名' value={user.owner} name='owner' onChange={onChange}></input>
                    </div>
                    <div className='row'>
                        <input placeholder='账号' value={user.userName} autoComplete='off' name='userName' onChange={onChange}></input>
                    </div>
                    <div className='row'>
                        <input placeholder='密码' value={user.password} autoComplete='off' type="password" name='password' onChange={onChange}></input>
                    </div>
                    <div className='row'>
                        <button onClick={confrom} className='btn'>登录</button>
                    </div>
                </div>
                <div className="bottom">
                    <a href="https://beian.miit.gov.cn" target="_blank" rel="noreferrer">沪ICP备13035718号</a>
                </div>
            </div>

        </div>
    )
}

export default Login
